export interface Lagersymbol {
  id: number;
  lagersymbol: string;
  bezeichnung: string;
}
